/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pin'
export default icon
